import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { Location } from "@angular/common";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { ShareDataService } from "../../services/shareDataServic";
import { CoreLanguageService } from "../../services/language.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { LoginActivationService } from "./loginActivation.service";
import { RegisterationUserViewModel } from "../../shared/models/registration.model";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { WebShopService } from "../../services/webShop.service";

@Component({
  selector: "loginActivation",
  templateUrl: "./loginActivation.component.html",
  styleUrls: ["./loginActivation.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginActivationComponent implements OnInit, OnDestroy {
  private langSubscriber: Subscription;
  private returnUrl: string = "";
  private registerationUserViewModel: RegisterationUserViewModel = new RegisterationUserViewModel();
  private newsletterOptIn: boolean = false;

  // used for show and hide password
  public hide: boolean = true;
  public loginActivationMainMessage: string = "";

  public loginActivationFailedMessage: string = ""; // when user login failed because user is not activated
  public userActivationInvalid: boolean = false; // when user login failed because user is not activated

  public loginPasswordVisibility: boolean = false; // used for show and hide password

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _loginActivationService: LoginActivationService
    , private _shareDataService: ShareDataService
    , private _snackBarService: SnackBarService
    , private _internationalisationService: InternationalisationService
    , private _router: Router
    , private _location: Location
    , private _webShopService: WebShopService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("LoginActivationComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.returnUrl = me._shareDataService.getSharedDateByKey("returnUrl");
    me.registerationUserViewModel = me._shareDataService.getSharedDateByKey("registerationUserViewModel");
    me.newsletterOptIn = me._shareDataService.getSharedDateByKey("newsletterOptIn") || false;
    me.loginActivationMainMessage = (me._coreLanguageService.value("phLoginActivation_MainMessage")).replace("<email>", me.registerationUserViewModel.userName);
    me.loginActivationFailedMessage = (me._coreLanguageService.value("phLoginActivation_Failed_Message")).replace("<email>", me.registerationUserViewModel.userName);

    me.langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });

    me._shareDataService.resetSharedData();
    this.PushChanges();
  }

  /**
   * try to activate user after registration and goes to the next registration step base on Response.
   */
  public async loginAvtivation(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const response = await me._loginActivationService.CheckUserActivation(me.registerationUserViewModel);
      if (response) {
        // User is now logged in - send newsletter opt-in if needed
        if (me.newsletterOptIn) {
          try {
            const newsletterSuccess = await me._webShopService.SetNewsletter(true);
            if (!newsletterSuccess) {
              me._coreLogService.error("LoginActivationComponent.loginAvtivation", "Newsletter opt-in failed after login");
            }
          } catch (error) {
            me._coreLogService.error("LoginActivationComponent.loginAvtivation", "Newsletter opt-in error", error);
          }
        }
        me._shareDataService.setSharedDataByKey("userName", me.registerationUserViewModel.userName);
        me._shareDataService.setSharedDataByKey("returnUrl", me.returnUrl);
        me._router.navigateByUrl("/registrationdata");
      } else {
        me.userActivationInvalid = true;
        me.PushChanges();
      }
    } catch (error) {
      me._snackBarService.ShowErrorMessageFailed(52);
    } finally {
      me._overlaySpinnerService.HideLayoutSpinner();
    }
  }

  /**
   * try to activate user after registration and goes to the next registration step base on Response.
   */

  public async resendLoginActivateRequest() { // async loading of the resend Login. 
    const me = this;
    try {
      me._overlaySpinnerService.ShowLayoutSpinner();
      await me._loginActivationService.ResendActivationRequest(me.registerationUserViewModel.userName);
      me._overlaySpinnerService.HideLayoutSpinner(); // no (this ->) or (if) is needed, because the code that is after the await statement is executed only when the ResendActivationRequest function completes.
      me._snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful);
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._snackBarService.ShowErrorMessageFailed(53);
    }
  }


  public ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }
}
